import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import { invalidateThreadQueries } from './useArCollectionThreads';

/**
 * Re-derive a collection thread's whole page from source: the invoice and its
 * cash from Famous, the evidence graph, then the AI recommended action.
 *
 * The backend runs those in order in one request (each feeds the next), so the
 * only job here is to drop every cached read the run could have moved. The
 * recommendation keys are invalidated without a threadId filter for the same
 * reason `invalidateThreadQueries` is broad: the panel that owns them is a
 * sibling with its own query, and re-evaluating one thread is rare enough that
 * refetching the others costs nothing.
 */
export function useReevaluateArCollectionThread() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.accountsReceivable.arCollectionThreads.reevaluate.mutationOptions({
      onSuccess: () => {
        invalidateThreadQueries(queryClient);
        void queryClient.invalidateQueries({
          queryKey: orpc.accountsReceivable.arInvoices.get.key(),
        });
        void queryClient.invalidateQueries({
          queryKey: orpc.accountsReceivable.arShortPayRecommendations.get.key(),
        });
        void queryClient.invalidateQueries({
          queryKey:
            orpc.accountsReceivable.arOverPaymentRecommendations.get.key(),
        });
      },
    }),
  );
}
